import { useState } from 'react'
import type { ZodType } from 'zod'
import { mensajeDeError } from './ModalMarco'

/**
 * Validación de un formulario de C8 con el mismo esquema que usa el
 * servidor. Devuelve errores por campo y el envío con estado.
 */
export function useFormulario<Entrada, Salida>(
  esquema: ZodType<Salida, Entrada>,
  enviar: (datos: Salida, valores: Entrada) => Promise<unknown>,
  alTerminar: () => void,
) {
  const [errores, setErrores] = useState<Record<string, string>>({})
  const [errorGeneral, setErrorGeneral] = useState<string | null>(null)
  const [ocupado, setOcupado] = useState(false)

  const limpiar = () => {
    setErrores({})
    setErrorGeneral(null)
  }

  const validarYEnviar = (valores: Entrada) => {
    const r = esquema.safeParse(valores)
    if (!r.success) {
      const porCampo: Record<string, string> = {}
      for (const issue of r.error.issues) {
        const clave = String(issue.path[0] ?? '')
        porCampo[clave] ??= issue.message
      }
      setErrores(porCampo)
      return
    }
    setErrores({})
    setErrorGeneral(null)
    setOcupado(true)
    enviar(r.data, valores)
      .then(() => {
        alTerminar()
      })
      .catch((e: unknown) => {
        setErrorGeneral(mensajeDeError(e))
      })
      .finally(() => {
        setOcupado(false)
      })
  }

  return { errores, errorGeneral, ocupado, validarYEnviar, limpiar }
}
